import {Button, Modal, Tab, Tabs} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../CoSoKBCB";
import {Formik, Form} from "formik";
import {addPhieuKeHoach, updateStatusDot, saveDot, updatePhieuKeHoach} from "../services/services";
import {CODE, TYPE_WH} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import NhanLuc from "./NhanLuc";
import YCTrangThietBi from "./YCTrangThietBi";
import DuDoanKinhPhi from "./DuDoanKinhPhi";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import {LEVEL_TYPE, STATUS} from "../constants/constansKeHoach";
import CustomTextDialog from "../../../../component/CustomTextDialog";
import {OctGenerateForm} from "@oceantech/oceantech-ui";
import NDLyThuyet from "./NDLyThuyet";
import HoanThanhKyThuat from "./HoanThanhKyThuat";
import CoSoVatChat from "./CoSoVatChat";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>;
  type: TypeKeHoach;
  isViewDot: boolean;
}

const DialogThongTinDot = (props: Props) => {
  const {show, onHide, setInitialValues, initialValues, type, isViewDot} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(isViewDot);
  const [activeTab, setActiveTab] = useState<string>("thongtin");
  const [openDialogConfirm, setOpenDialogConfirm] = useState<boolean>(false);
  console.log(initialValues)
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});

  const [dataNhanLuc, setDataNhanLuc] = useState<any>({
    tuyenTren: [],
    tuyenDuoi: [],
  });

  const [equipmentList, setEquipmentList] = useState<any>([]);
  const [ndLyThuyetList, setNdLyThuyetList] = useState<any>([]);
  const [htKyThuatList, setHtKyThuatList] = useState<any>([]);
  const [coSoVatChatList, setCoSoVatChatList] = useState<any>([]);

  const [budget, setBudget] = useState<any>({
    totalBudget: '',
    studentPayPercent: '',
    studentPayAmount: '',
    stateBudgetPercent: '',
    stateBudgetAmount: ''
  });

  const handleFormSubmit = async (values: any) => {
    if (!dataNhanLuc.tuyenTren.length && !dataNhanLuc.tuyenDuoi.length) {
      toast.warning('Vui lòng thêm ít nhất một thành viên');
      return;
    }

    const dataSubmit = {
      ...values.dotChuyenGiao,
      staffList: [...dataNhanLuc.tuyenTren, ...dataNhanLuc.tuyenDuoi],
      equipmentList,
      budget,
      ndLyThuyetList,
      htKyThuatList,
      coSoVatChatList,
    };

    try {
      setIsLoading(true);
      console.log(values)
      const id = values.dotChuyenGiao?.id;
      const {data} = await saveDot(id, dataSubmit)

      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        // setInitialValues && setInitialValues(data?.data);
        // setDetailPhieuKeHoach({
        //   ...data?.data,
        //   statusId: detailPhieuKeHoach?.statusId,
        // });
        toast.success("Thành công");

        loadDataFromInitialValues(data?.data);
        handleClose()

      } else {
        let errorMessage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMessage);
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  const handlerUpdateStatus = async (values: any) => {

    const dataSubmit = {
      status: values?.status,
      description: values?.description
    };

    try {
      setIsLoading(true);
      const id = initialValues.dotChuyenGiao?.id;
      const {data} = await updateStatusDot(id, dataSubmit)

      if (CODE.SUCCESS === data?.code) {
        setOpenDialogConfirm(false);
        onHide();
      } else {
        // let errorMessage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        // toast.warning(errorMessage);
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadDataFromInitialValues = (data: any) => {
    if (data?.dotChuyenGiao?.id) {
      setDsKeHoach(data?.dotChuyenGiao?.listOfInstructions || []);

      if (data?.dotChuyenGiao?.staffList) {
        setDataNhanLuc({
          tuyenTren: data?.dotChuyenGiao?.staffList.filter((x: any) => x.levelType === LEVEL_TYPE.UPPER) || [],
          tuyenDuoi: data?.dotChuyenGiao?.staffList.filter((x: any) => x.levelType === LEVEL_TYPE.LOWER) || [],
          coSoVatChatList: data?.dotChuyenGiao?.coSoVatChatList,
          htKyThuatList: data?.dotChuyenGiao?.htKyThuatList,
        });
      }

      if (data?.dotChuyenGiao?.ndLyThuyetList) {
        setNdLyThuyetList(data?.dotChuyenGiao?.ndLyThuyetList || []);
      }

      if (data?.dotChuyenGiao?.coSoVatChatList) {
        setCoSoVatChatList(data?.dotChuyenGiao?.coSoVatChatList || []);
      }

      if (data?.dotChuyenGiao?.htKyThuatList) {
        setHtKyThuatList(data?.dotChuyenGiao?.htKyThuatList || []);
      }

      if (data?.dotChuyenGiao?.equipmentList) {
        setEquipmentList(data?.dotChuyenGiao?.equipmentList || []);
      }

      if (data?.dotChuyenGiao?.budget) {
        setBudget(data?.dotChuyenGiao?.budget);
      }
    }
  };

  useEffect(() => {
    if (initialValues?.dotChuyenGiao?.id) {
      loadDataFromInitialValues(initialValues);
      setIsView(initialValues?.dotChuyenGiao?.statusCode !== 'pending_deployment' || false);
    }
  }, [initialValues?.dotChuyenGiao?.id]);

  useEffect(() => {
    updateForm();
    updateFormVatTu();
  }, []);

  const updateFormVatTu = async () => {
    if (!type?.formVatTu) return;
    const data = await generateForm(type?.formVatTu, setIsLoading);
    setListJsonGenerateVT(data || []);
    setInitialValuesFormThemVT(generateInitValues(data));
  };

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
  };

  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };

  const handleClose = () => {
    setDataNhanLuc({tuyenTren: [], tuyenDuoi: []});
    setEquipmentList([]);
    setBudget({
      totalBudget: '',
      studentPayPercent: '',
      studentPayAmount: '',
      stateBudgetPercent: '',
      stateBudgetAmount: ''
    });
    setActiveTab("thongtin");
    setIsView(false);
    setOpenDialogConfirm(false);
    onHide();
  };

  console.log(initialValues)
  // const getStatusName = (code:any) => STATUS[code]?.name ?? "";
  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{dotChuyenGiao: {...initialValuesFormThemVT, ...initialValues?.dotChuyenGiao}}}
        validationSchema={generateValidationSchema(listJsonGenerateVT, 'dotChuyenGiao')}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader
                onHide={handleClose}
                title={`${values?.dotChuyenGiao?.id ? 'Cập nhật' : 'Thêm mới'} thông tin bước`}
              />
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10 modal-body-scroll">
                  {/* Thông tin chung */}
                  <div className="">
                    <div className="section-block mt-2">
                      <div className="spaces title">
                        <span className="text-title fw-bold fs-5 spaces mb-5">Nội dung chuyển giao</span>
                      </div>
                      <OctGenerateForm
                        isView={isView}
                        listFieldAuto={listJsonGenerate}
                        handleChange={handleChange}
                        setValues={setValues}
                        values={values}
                        touched={touched}
                        errors={errors}
                        propsRenderButton={handler}
                        lstSelectedRenderButton={dsKeHoach}
                        setFieldValue={setFieldValue}
                        modelID={"dotChuyenGiao"}
                        customComponent={DynamicComponent}
                      />
                    </div>
                    {/* Tab Nội dung lý thuyết */}
                    {!initialValues?.dotChuyenGiao?.index && <div className="section-block">
                      <NDLyThuyet
                        initialValues={initialValues}
                        setInitialValues={setInitialValues}
                        dataTrangThietBi={ndLyThuyetList}
                        setDataTrangThietBi={setNdLyThuyetList}
                        isView={isView}
                      />
                    </div>}
                    {/* Tab Chỉ tiêu nội dung hoàn thành kỹ thuật */}
                    {!initialValues?.dotChuyenGiao?.index && <div className="section-block">
                      <HoanThanhKyThuat
                        initialValues={initialValues}
                        setInitialValues={setInitialValues}
                        dataTrangThietBi={htKyThuatList}
                        setDataTrangThietBi={setHtKyThuatList}
                        isView={isView}
                      />
                    </div>}
                    {/* Tab NhanLuc */}
                    <div className="section-block">
                      <NhanLuc
                        dataNhanLuc={dataNhanLuc}
                        setDataNhanLuc={setDataNhanLuc}
                        isView={isView}
                      />
                    </div>

                    {/* Tab Cơ sở vật chất */}
                    <div className="section-block">
                      <CoSoVatChat
                        initialValues={initialValues}
                        setInitialValues={setInitialValues}
                        dataTrangThietBi={coSoVatChatList}
                        setDataTrangThietBi={setCoSoVatChatList}
                        isView={isView}
                      />
                    </div>
                    {/* Tab Trang thiết bị */}
                    <div className="section-block">
                      <YCTrangThietBi
                        initialValues={initialValues}
                        setInitialValues={setInitialValues}
                        dataTrangThietBi={equipmentList}
                        setDataTrangThietBi={setEquipmentList}
                        isView={isView}
                      />
                    </div>
                    {/* Tab Kinh phí */}
                    <div className="section-block">
                      {/* <h5 className="section-title">Dự đoán kinh phí</h5> */}
                      <DuDoanKinhPhi
                        initialValues={initialValues}
                        setInitialValues={setInitialValues}
                        type={type}
                        dataKinhPhi={budget}
                        setDataKinhPhi={setBudget}
                        isView={isView}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>

              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {(values.dotChuyenGiao?.id || detailPhieuKeHoach?.id) && !isView && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                    }}

                    handleClick={(data: any) => {
                      data.code === "deployed" && setIsView(true);
                    }}
                    onHide={onHide}
                    tracker={type.trackerCode}
                    objectId={values.dotChuyenGiao?.id || detailPhieuKeHoach?.id}
                  />
                )}
                {!isView && (
                  <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                    <IconButtonSave/> Lưu
                  </Button>
                )}
                <Button
                  type="button"
                  className="btn btn-secondary min-w-120px spaces mx-3"
                  onClick={handleClose}
                >
                  Đóng
                </Button>
                {/*{Number(initialValues.dotChuyenGiao?.status) < 6 && initialValues.dotChuyenGiao?.techTransferInfoId &&*/}
                {/*    <Button*/}
                {/*        type="button"*/}
                {/*        className="btn btn-fill min-w-120px spaces mx-3"*/}
                {/*        onClick={() => setOpenDialogConfirm(true)}*/}
                {/*    >*/}
                {/*      /!* {STATUS[Number(initialValues.dotChuyenGiao?.status) as 1 | 2 | 3 | 4 | 5 | 6]?.name} *!/*/}
                {/*        Hoàn thành*/}
                {/*    </Button>*/}

                {/*}*/}
              </div>

            </Form>

          </>

        )}

      </Formik>

      {openDialogConfirm &&
          <CustomTextDialog
              show={openDialogConfirm}
              onCloseClick={() => setOpenDialogConfirm(false)}
              onYesClick={(e) => {
                handlerUpdateStatus({
                  status: STATUS[Number(initialValues.dotChuyenGiao?.status) as 1 | 2 | 3 | 4 | 5 | 6]?.code + 1,
                  description: e
                });
              }}
              title={` Đánh giá ${STATUS[Number(initialValues.dotChuyenGiao?.status) as 1 | 2 | 3 | 4 | 5 | 6]?.name} `}
              message={`Thêm đánh giá`}
              yes="Đồng ý"
              close="Đóng"
          />
      }
    </Modal>
  );
};

export default DialogThongTinDot;